import MobileRoutingTable from 'app/MobileRoutingTable';
import RoutingTable from 'app/RoutingTable';
import { DeviceContext } from './Device.context';

export const DeviceProvider = ({ children }: { children: React.ReactNode }) => {
  // Match ANY app version (SpeedchainMobile/<id>/<version>), not just 1.0 — a
  // version bump must not silently drop the shell to the desktop RoutingTable
  // (which would also let the login flow attempt WebAuthn inside the WebView,
  // where it's blocked). Kept in sync with MOBILE_UA_REGEX in authSlice.ts.
  const isMobileApp = /SpeedchainMobile\/[^/]+\/\d+(\.\d+)*/.test(navigator.userAgent);

  return (
    <DeviceContext.Provider value={{ isMobileApp }}>
      {isMobileApp ? <MobileRoutingTable /> : <RoutingTable />}
      {children}
    </DeviceContext.Provider>
  );
};
